import { EBSModel } from "@shared/models";
import { FormatDatesService } from "@shared/services";

export class EBS {
  id:                         number;
  assignment_id:              number;

  created_at:                 Date;
  confirmed_at?:              Date;
  assignment_provisioned_on?: Date;

  version:                    number;
  external_name:              string;
  title:                      string;

  aufadresse1:                string;
  aufansprech1:               string;
  anspr_telefon:              string;
  aufarbs:                    string[];
  aufarbzeitwoche:            string;
  aufberuf:                   string;
  aufbetrstaette:             string;
  aufdeckelbetragakt:         number;
  auffahrbetrag:              string;
  aufgefahrarbeit:            string;
  aufmuhrzeit:                string;
  aufpostaet1:                string;
  auftarifbranche:            string;
  auftarifgruppe:             string;
  auftarifmagruppe:           string;
  auftarifvertrag:            string;
  auftelefon1:                string;
  auftextmarken4:             string;
  aufueberlbeginn:            string;
  aufuebernbetrag:            string;
  aufueentfernung:            string;
  aufuntersuchidx:            string;
  aufvmabetrag:               string;
  filtelefon1:                string;
  internal_contact_persnr:    number;
  kundname1:                  string;
  kundort:                    string;
  kundplz:                    string;
  kundstrasse:                string;
  pel705preis:                string;
  persname:                   string;
  persvorname:                string;
  txt_sonstigeZulage:         string;
  aufpostaet1_text:           string;

  assignmentLocationStreet:   string;
  assignmentLocationZipCode:  string;
  assignmentLocationCity:     string;

  constructor(data: EBSModel | EBS) {
    this.id                        = data.id;
    this.assignment_id             = data.assignment_id;

    this.created_at                = FormatDatesService.parseDate(data.created_at);
    this.confirmed_at              = FormatDatesService.parseDate(data.confirmed_at);
    this.assignment_provisioned_on = FormatDatesService.parseDate(data.assignment_provisioned_on);

    this.version                   = data.version;
    this.external_name             = `${data.persvorname} ${data.persname}`;
    this.title                     = data.title;

    this.aufadresse1               = data.aufadresse1;
    this.aufansprech1              = data.aufansprech1;
    this.anspr_telefon             = data.anspr_telefon;
    this.aufberuf                  = data.aufberuf;
    this.aufbetrstaette            = data.aufbetrstaette;
    this.aufdeckelbetragakt        = data.aufdeckelbetragakt;
    this.aufgefahrarbeit           = data.aufgefahrarbeit;
    this.aufmuhrzeit               = data.aufmuhrzeit;
    this.aufpostaet1               = data.aufpostaet1;
    this.auftarifbranche           = data.auftarifbranche;
    this.auftarifgruppe            = data.auftarifgruppe;
    this.auftarifmagruppe          = data.auftarifmagruppe;
    this.auftarifvertrag           = data.auftarifvertrag;
    this.auftelefon1               = data.auftelefon1;
    this.auftextmarken4            = data.auftextmarken4;
    this.aufueberlbeginn           = data.aufueberlbeginn;
    this.aufuntersuchidx           = data.aufuntersuchidx;
    this.filtelefon1               = data.filtelefon1;
    this.internal_contact_persnr   = data.internal_contact_persnr;
    this.kundname1                 = data.kundname1;
    this.kundort                   = data.kundort;
    this.kundplz                   = data.kundplz;
    this.kundstrasse               = data.kundstrasse;
    this.persname                  = data.persname;
    this.persvorname               = data.persvorname;
    this.aufpostaet1_text          = data.aufpostaet1_text;

    this.aufarbs                   = FormatDatesService.parseStringToArray(data.aufarbs);
    this.aufarbzeitwoche           = FormatDatesService.parseToPayFormat(data.aufarbzeitwoche, 1);
    this.auffahrbetrag             = FormatDatesService.parseToPayFormat(data.auffahrbetrag);
    this.aufuebernbetrag           = FormatDatesService.parseToPayFormat(data.aufuebernbetrag);
    this.aufueentfernung           = FormatDatesService.parseToPayFormat(data.aufueentfernung);
    this.aufvmabetrag              = FormatDatesService.parseToPayFormat(data.aufvmabetrag);
    this.pel705preis               = FormatDatesService.parseToPayFormat(data.pel705preis);
    this.txt_sonstigeZulage        = FormatDatesService.parseToPayFormat(data.txt_sonstigeZulage);
  }

  get titleWithVersionNumber(): string {
    return this.title + ' v'+(this.version > 10 ? this.version : '0' + this.version);
  }

  toJSON(): EBSModel {
    return {
      id:                        this.id                        ? this.id                        : null,
      assignment_id:             this.assignment_id             ? this.assignment_id             : null,
      created_at:                FormatDatesService.parseDateISO(this.created_at),
      confirmed_at:              FormatDatesService.parseDateISO(this.confirmed_at),
      assignment_provisioned_on: FormatDatesService.parseDateISO(this.assignment_provisioned_on),
      version:                   this.version                   ? this.version                   : null,
      title:                     this.title                     ? this.title                     : null,

      assignmentLocationStreet:  this.assignmentLocationStreet  ? this.assignmentLocationStreet  : null,
      assignmentLocationZipCode: this.assignmentLocationZipCode ? this.assignmentLocationZipCode : null,
      assignmentLocationCity:    this.assignmentLocationCity    ? this.assignmentLocationCity    : null,

      aufadresse1:               this.aufadresse1               ? this.aufadresse1               : null,
      aufansprech1:              this.aufansprech1              ? this.aufansprech1              : null,
      anspr_telefon:             this.anspr_telefon             ? this.anspr_telefon             : null,
      aufberuf:                  this.aufberuf                  ? this.aufberuf                  : null,
      aufbetrstaette:            this.aufbetrstaette            ? this.aufbetrstaette            : null,
      aufdeckelbetragakt:        this.aufdeckelbetragakt        ? this.aufdeckelbetragakt        : null,
      aufgefahrarbeit:           this.aufgefahrarbeit           ? this.aufgefahrarbeit           : null,
      aufmuhrzeit:               this.aufmuhrzeit               ? this.aufmuhrzeit               : null,
      aufpostaet1:               this.aufpostaet1               ? this.aufpostaet1               : null,
      auftarifbranche:           this.auftarifbranche           ? this.auftarifbranche           : null,
      auftarifgruppe:            this.auftarifgruppe            ? this.auftarifgruppe            : null,
      auftarifmagruppe:          this.auftarifmagruppe          ? this.auftarifmagruppe          : null,
      auftarifvertrag:           this.auftarifvertrag           ? this.auftarifvertrag           : null,
      auftelefon1:               this.auftelefon1               ? this.auftelefon1               : null,
      auftextmarken4:            this.auftextmarken4            ? this.auftextmarken4            : null,
      aufueberlbeginn:           this.aufueberlbeginn           ? this.aufueberlbeginn           : null,
      aufuntersuchidx:           this.aufuntersuchidx           ? this.aufuntersuchidx           : null,
      filtelefon1:               this.filtelefon1               ? this.filtelefon1               : null,
      internal_contact_persnr:   this.internal_contact_persnr   ? this.internal_contact_persnr   : null,
      kundname1:                 this.kundname1                 ? this.kundname1                 : null,
      kundort:                   this.kundort                   ? this.kundort                   : null,
      kundplz:                   this.kundplz                   ? this.kundplz                   : null,
      kundstrasse:               this.kundstrasse               ? this.kundstrasse               : null,
      persname:                  this.persname                  ? this.persname                  : null,
      persvorname:               this.persvorname               ? this.persvorname               : null,
      aufpostaet1_text:          this.aufpostaet1_text          ? this.aufpostaet1_text          : null,

      aufarbs:                   FormatDatesService.parseArrayToString(this.aufarbs),
      aufarbzeitwoche:           FormatDatesService.parseComaStringToNumber(this.aufarbzeitwoche),
      auffahrbetrag:             FormatDatesService.parseComaStringToNumber(this.auffahrbetrag),
      aufuebernbetrag:           FormatDatesService.parseComaStringToNumber(this.aufuebernbetrag),
      aufueentfernung:           FormatDatesService.parseComaStringToNumber(this.aufueentfernung),
      aufvmabetrag:              FormatDatesService.parseComaStringToNumber(this.aufvmabetrag),
      pel705preis:               FormatDatesService.parseComaStringToNumber(this.pel705preis),
      txt_sonstigeZulage:        FormatDatesService.parseComaStringToNumber(this.txt_sonstigeZulage),
    };
  }

}
